import { RESET_STATE } from 'src/redux/actions';
import { plantsActionTypes } from './plantsActionTypes';
const { LIST_PLANTS, FILTER_PLANT_NAME, FILTER_PLANT_FOR_FORM } =
	plantsActionTypes;
const intialState = {
	plants: [],
	plantName: [],
	formFilter: '',
};

export const plantsReducer = (state = intialState, { type, payload }) => {
	switch (type) {
		case LIST_PLANTS:
			return { ...state, plants: payload };
		case FILTER_PLANT_NAME:
			return { ...state, plantName: payload };
		case FILTER_PLANT_FOR_FORM:
			return { ...state, formFilter: payload };
		case RESET_STATE:
			return intialState;
		default:
			return state;
	}
};
